<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.auth.username">
      </form-group>
      <form-group label="Chave">
        <input class="form-input" v-model="config.auth.password">
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
        <form-group label="Enviar informação de prazo extra">
          <label class="form-switch">
            <input type="checkbox" v-model="config.product.forwardCrossDocking">
            <span class="form-switch__indicator"></span>
          </label>
          <small class="form-help">Define se a informação de prazo extra dos produtos será sincronizada com o marketplace.</small>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados na Colombo.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados na Colombo.</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'colombo'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'colombo',
      config: {
        auth: {
          environment: 'sandbox',
          username: null,
          password: null
        },
        product: {
          forwardCrossDocking: false,
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        quotation: {
          shipmentMethod: null
        },
        synchronize: {
          stock: true,
          price: true
        }
      },
      synchronizeOptions: [
        true,
        false
      ]
    }),
    updated () {
      delete this.config.auth.token
    },
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ])
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Colombo.vue?75c33328